import type { ChangeEvent, KeyboardEvent } from 'react'

import { SearchOutlined } from '@ant-design/icons'
import { Button, Input, Space } from 'antd'
import { useState } from 'react'

interface Props {
  placeholder?: string
  defaultValue?: string | undefined

  onSearch: (value: string | undefined) => void
  onClear: () => void
}

export const OuterTableTextFilter = (props: Props): JSX.Element => {
  const [value, setValue] = useState(props.defaultValue ?? '')

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    if (event.type === 'click') {
      setValue('')
      props?.onClear()
    } else {
      setValue(event.target.value)
    }
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      props?.onSearch?.(value)
    }
  }

  const handleClick = (): void => {
    props?.onSearch?.(value)
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Input
        placeholder={props.placeholder ?? 'Search by actor, action, type'}
        className='font-lato text-sm py-1 bg-gray-50 [&_input]:bg-transparent rounded [&_input]:placeholder:text-gray-400'
        allowClear
        prefix={<SearchOutlined className='text-gray-500' />}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      <Button type='default' onClick={handleClick}>
        Apply
      </Button>
    </Space.Compact>
  )
}
